import { gql, type TypedDocumentNode } from "@apollo/client";
import type { PaginationVariables } from "@/components/Pagination/Pagination";
import { PAGE_INFO_FRAGMENT } from "@/hooks/usePagination";
import type { AchievementForMembersFiltersInput, AchievementReportNode } from "./types";

export type AchievementForMembersSortField =
  | "EXPIRES_ON"
  | "MEMBER_CLASS"
  | "NAME"
  | "PGA_ID"
  | "RECOGNITION_YEAR"
  | "RECOGNIZED_AT"
  | "RECOGNIZING_ENTITY"
  | "REMARKS"
  | "REPORTING_ENTITY"
  | "SECTION_NAME"
  | "STATUS"
  | "TITLE";

export type AchievementForMembersOrderByInput = {
  field: AchievementForMembersSortField;
  direction: "ASC" | "DESC";
};

export type AchievementsForMembersQueryResponse = {
  achievementsForMembers: {
    nodes: AchievementReportNode[];
    pageInfo: {
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string;
      endCursor?: string;
    };
    totalCount: number;
  };
};

export type AchievementsForMembersQueryVariables = PaginationVariables & {
  achievementId: string;
  orderBy?: AchievementForMembersOrderByInput;
  filters?: AchievementForMembersFiltersInput;
};

export const ACHIEVEMENTS_FOR_MEMBERS_QUERY: TypedDocumentNode<
  AchievementsForMembersQueryResponse,
  AchievementsForMembersQueryVariables
> = gql`
  query AchievementsForMembers(
    $achievementId: ID!
    $first: Int
    $last: Int
    $before: String
    $after: String
    $orderBy: BackofficeAchievementsAchievementForMembersOrderByInput
    $filters: BackofficeAchievementsAchievementForMembersFiltersInput
  ) {
    achievementsForMembers(
      achievementId: $achievementId
      first: $first
      last: $last
      before: $before
      after: $after
      orderBy: $orderBy
      filters: $filters
    ) {
      nodes {
        name
        status
        title
        pgaId
        memberClass
        sectionName
        recognizedAt
        recognitionYear
        reportingEntity
        recognizingEntity
        expiresOn
        remarks
      }
      ...PageInfo
    }
  }
  ${PAGE_INFO_FRAGMENT}
`;
